if (!window._colorHoverInitialized) {
  window._colorHoverInitialized = true;

  function isMobile() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function getProductUrl(card, variantId) {
    var productLink = card.querySelector('a.full-unstyled-link');
    if (!productLink) return null;
    var url = productLink.href;
    if (variantId) url += '?variant=' + variantId;
    return url;
  }

  function initCard(card) {
    if (card._colorHoverBound) return;
    card._colorHoverBound = true;

    var mainImg = card.querySelector('.card__media .media img:first-child');
    if (!mainImg) return;

    var thumbsContainer = card.querySelector('.color-thumbnails');
    if (!thumbsContainer) return;

    var originalSrc = mainImg.src;
    var originalSrcset = mainImg.srcset;
    var activeVariantId = null;

    thumbsContainer.querySelectorAll('img[data-full-src]').forEach(function (thumb) {
      var preload = new Image();
      preload.src = thumb.dataset.fullSrc;

      thumb.addEventListener('mouseenter', function () {
        if (isMobile()) return;
        mainImg.srcset = '';
        mainImg.src = this.dataset.fullSrc;
        activeVariantId = this.dataset.variantId;
      });

      thumb.addEventListener('click', function (e) {
        if (isMobile()) {
          e.preventDefault();
          e.stopPropagation();
          mainImg.srcset = '';
          mainImg.src = this.dataset.fullSrc;
          activeVariantId = this.dataset.variantId || null;
        } else {
          var url = getProductUrl(card, this.dataset.variantId);
          if (url) window.location.href = url;
        }
      });
    });

    thumbsContainer.addEventListener('mouseleave', function () {
      if (isMobile()) return;
      mainImg.src = originalSrc;
      mainImg.srcset = originalSrcset;
      activeVariantId = null;
    });

    var cardLinks = card.querySelectorAll('a.full-unstyled-link');
    cardLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (!isMobile()) return;
        if (!activeVariantId) return;
        e.preventDefault();
        var url = getProductUrl(card, activeVariantId);
        if (url) window.location.href = url;
      });
    });
  }

  function initAllCards() {
    document.querySelectorAll('.card-wrapper.has-color-thumbnails').forEach(initCard);
  }

  // Inicialización inicial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCards);
  } else {
    initAllCards();
  }

  // Observar cambios en el DOM para cuando Shopify recarga el grid via AJAX
  var observer = new MutationObserver(function (mutations) {
    var shouldReinit = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('card-wrapper')) {
            shouldReinit = true;
          } else if (node.querySelector && node.querySelector('.card-wrapper')) {
            shouldReinit = true;
          }
        }
      });
    });
    if (shouldReinit) initAllCards();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}